import React from "react";

function Separator({ width, height, hideInMobile, color }) {
  const hideClassName = hideInMobile ? "hide-m" : "";
  const borderColorClassName = color ? `1px solid ${color}` : "";
  return (
    <hr
      className={`separator ${hideClassName}`}
      style={{ width, height, borderTop: borderColorClassName }}
    />
  );
}

export default Separator;
